module.exports = __webpack_public_path__ + "static/talk-9-140bb7b71f64012d5250a2fcebe8b28b.png";